import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import AddParticipantDialog from "./AddParticipantDialog.js";
import { fakeArrayProfessions, VENTE_RELATION } from "../services/utils.js";
import { createParticipant } from "../services/api.js";
import Recu from "./Recu.js";
import ServicePrincipal from "../services/ServicePrincipal.js";

export const initialData = {
  referenceId: "",         // Référence ID (disabled)
  nom: "",                 // Nom
  prenoms: "",             // Prénoms
  dateNaissance: "",       // Date de naissance
  age: "",                 // Âge (disabled)
  genre: "",               // Genre
  profession: "",          // Profession
  pays: "",                // Pays
  ville: "",               // Ville
  commune: "",             // Commune
  quartier: "",            // Quartier
  telephone: "",           // Téléphone
  email: "",               // Email
};


export const AddParticipant = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(initialData);
  const [errors, setErrors] = useState({
    referenceId: false,
    nom: false,
    prenoms: false,
    dateNaissance: false,
    age: false,
    genre: false,
    profession: false,
    pays: false,
    ville: false,
    commune: false,
    quartier: false,
    telephone: false,
    email: false,
  });
  const [professions, setProfessions] = useState([]);
  const [showRecu, setShowRecu] = useState(false)
  const [infosVente, setInfosVente] = useState(null)
  const [infosParticipant, setInfosParticipant] = useState(null)

  const principalService = new ServicePrincipal();

  const urlParams = new URLSearchParams(window.location.search);
  const venteId = urlParams.get('vente');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setErrors({ ...errors, [name]: false });
  };

  const validateFields = () => {
    const newErrors = {
      telephone: !data.telephone.trim(),
      nom: false,
      prenoms: false,
      dateNaissance: false,
      genre: false,
      profession: false,
      pays: false,
      ville: false,
      email: false,
      // Les champs optionnels peuvent rester false
      referenceId: false,
      age: false,
      commune: false,
      quartier: false,
      intentionEncherir: false,
    };

    setErrors(newErrors);
    return !Object.values(newErrors).some((e) => e);
  };

  const handleSubmit = async () => {
    if (!validateFields()) return;
    setLoading(true);
    swal({
      title: "Ajout de participant",
      text: "Voulez-vous enregistrer ce participant ?",
      icon: "warning",
      buttons: {
        cancel: {
          text: "Annuler",
          visible: true,
          className: "btn btn-secondary",
          closeModal: true,
        },
        confirm: {
          text: "Confirmer",
          visible: true,
          className: "btn btn-success",
          closeModal: true,
        },
      },
    }).then(async (willSubmit) => {
      if (willSubmit) {
        try {
          // Fonction utilitaire pour éviter les erreurs sur les valeurs nulles
          const toLower = (str) => (str && typeof str === 'string' ? str.toLowerCase().trim() : str);

          const payload = {
            age: data.age,
            anneeNaissance: data.dateNaissance,
            commune: toLower(data.commune),
            email: data.email,
            genre: data.genre,
            isEncherisseur: false,
            nom: toLower(data.nom),
            pays: data.pays,
            prenoms: toLower(data.prenoms),
            profession: data.profession,
            quartier: toLower(data.quartier),
            reference: data.referenceId, // Souvent une ID, peut-être garder tel quel ?
            telephone: data.telephone.replace(/[\s-]/g, ""),
            ville: data.ville,
            autreVille: toLower(data.autreVille),
            autrePays: toLower(data.autrePays),
            autreProfession: toLower(data.autreProfession),
            [VENTE_RELATION]: venteId ? parseInt(venteId) : null 
          };

          const res = await createParticipant(payload);
          setInfosParticipant(res)
          swal("Participant ajouté avec succès !", {
            icon: "success",
            buttons: {
              confirm: {
                text: "OK",
                className: "btn btn-success",
              },
            },
          }).then(() => {
            setShowRecu(true);
          });
        } catch (error) {
          console.error("Erreur lors de la création :", error);
          swal("Une erreur est survenue", { icon: "error" });
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };


  const handleDownload = () => {
    const element = document.getElementById("recu");
    if (element) {
      const htmlContent = element.innerHTML;
      const blob = new Blob([htmlContent], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `recu_inscription_${data.prenoms}_${data.nom}.html`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  // Simulation du fetch des listes (roles, nationalités, fonctions, tpi)
  useEffect(() => {
    setProfessions(fakeArrayProfessions)
  }, []);


  useEffect(() => {
    const fetchVenteDetails = async () => {
      if (venteId) {
        try {
          const venteIdParsed = parseInt(venteId);
          const venteData = await principalService.fetchVentes(venteIdParsed);
          console.log("🚀 ~ fetchVenteDetails ~ venteData:", venteData)
          setInfosVente(venteData)
        } catch (error) {
          console.error("Erreur lors de la récupération des détails de la vente :", error);
        }
      }
    };
    fetchVenteDetails();
  }, [venteId]);



  return (
    <Box>
      <AddParticipantDialog
        data={data}
        infosParticipant={infosParticipant}
        infosVente={infosVente}
        setData={setData}
        handleChange={handleChange}
        errors={errors}
        handleSubmit={handleSubmit}
        loading={loading}
        professions={professions}
        showRecu={showRecu}
        setShowRecu={setShowRecu}
        handleDownload={handleDownload}
      />
    </Box>
  );
};
